import { useTranslation } from "react-i18next";
import InterviewDocList from "./InterviewDocList";
import IconInterview from "../../../../layout/others/icon_interview.svg";
import "../../../styles/header.scss";

export default function InterviewDocPage(props) {
  const { t } = useTranslation();

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={IconInterview} alt="ni-icon" />
            <h1>{t("DOCOnline")}</h1>
          </div>
          <div className="subtitle">{t("Recruitment / DocOnline")}</div>
        </div>
      </header>
      <InterviewDocList date={props.date} />
    </>
  );
}
